import { render, staticRenderFns } from "./AddressDataOld.vue?vue&type=template&id=7824e0d3&scoped=true"
import script from "./AddressDataOld.vue?vue&type=script&lang=js"
export * from "./AddressDataOld.vue?vue&type=script&lang=js"
import style0 from "./AddressDataOld.vue?vue&type=style&index=0&id=7824e0d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7824e0d3",
  null
  
)

export default component.exports